import api, { API_BASE, defaultOpt } from "./apiService";
import { filterTable, findTableRow, rowTransform } from "./tableUtils";

export async function getAllKapton() {
  return (await api.get(`${API_BASE}/list-kapton`)).data;
}

export async function addKapton(formAdd) {
  return (await api.post(`${API_BASE}/add-kapton`, formAdd, defaultOpt())).data;
}

export async function deleteKapton(id) {
  return (await api.delete(`${API_BASE}/delete-kapton/${id}`, defaultOpt()))
    .data;
}

export async function updateKapton(id, form) {
  return (await api.put(`${API_BASE}/update-kapton/${id}`, form, defaultOpt()))
    .data;
}

// Additional display data
const __map__ = {
  F0W: "CEE Full",
  F0T: "CEH Full",
  BLW: "CEE LD Bottom",
  BLT: "CEH LD Bottom",
  TLW: "CEE LD Top",
  TLT: "CEH LD Top",
  "5LW": "CEE LD Five",
  "5LT": "CEH LD Five",
  LLW: "CEE LD Left",
  RLW: "CEE LD Right",
  LLT: "CEH LD Left",
  RLT: "CEH LD Right",
  LHW: "CEE HD Left",
  RHW: "CEE HD Right",
  BHW: "CEE HD Bottom",
  THT: "CEH HD Top",
};

export function getKaptonTypeDisplay(type) {
  return type in __map__ ? __map__[type] : "UNKNOWN";
}

export const kaptonGeometryOptions = Object.keys(__map__).map((key) => ({
  value: key,
  label: `(${key}) ${__map__[key]}`,
}));

const __s_map__ = {
  LEIT: "Leiton",
  AMPH: "Amphenol Trackwise (CERN/UK)",
  CAPE: "CAPEL TECHNOLOGY (CERN/CN)",
};

export function kaptonSourceDisplay(source) {
  return source in __s_map__ ? `[${source}] ${__s_map__[source]}` : "UNKNOWN";
}

export const kaptonSourceOptions = Object.keys(__s_map__).map((key) => ({
  value: key,
  label: __s_map__[key],
}));

export function makeKaptonOptions(kaptonList, bpType, hideExhaust = false) {
  let options = filterTable(kaptonList, (kap) =>
    hideExhaust ? kap.available > 0 : true,
  );
  options = filterTable(options, (kap) => {
    if (!bpType) return true;
    if (bpType[0] === "S")
      return bpType.substring(1, 3) === kap.type.substring(1, 3);
    if (bpType[0] === "F")
      return bpType[2] === kap.type[2] && kap.type[0] === "F";
    return bpType === kap.type;
  });
  return rowTransform(options, (kap) => ({
    value: kap.id,
    label: `${kap.batch_id} (${kap.type})`,
    available: kap.available > 0,
  }));
}

export function kaptonDescription(kaptonList, id) {
  const kap = findTableRow(kaptonList, (kap) => kap.id === id);
  return kap ? `${kap.batch_id} : ${kap.type}` : "--";
}
